import React from 'react';
import classNames from 'classnames';

const getVisuallyHiddenProps = ({ className, ...props })=> {
  return {
    className: classNames('visually-hidden', className),
    ...props
  };
};

export const VisuallyHiddenSpan = (props)=>
  <span { ...getVisuallyHiddenProps(props) } />;

export const VisuallyHiddenP = (props)=>
  <p { ...getVisuallyHiddenProps(props) } />;

export const VisuallyHiddenH3 = (props)=>
  <h3 { ...getVisuallyHiddenProps(props) } />;
